// Generated by scripts/build-ui-icons.mjs.
export { ChatsCircle as default } from "../ui/glyphs-2";
